import { FC, useMemo } from "react";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { DateCalendar } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { DialogContent, DialogTitle, DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../shell/store/types";
import { getDateFnsLocale } from "shell/i18n/dates";
type DateFilterModal = {
  open: boolean;
  type: "on" | "before" | "after";
  onClose: () => void;
  setDateCallback: (date: Date) => void;
};
export const DateFilterModal: FC<DateFilterModal> = ({
  open,
  onClose,
  type,
  setDateCallback
}) => {
  const {
    i18n
  } = useTranslation();
  const activeFilter = useSelector((state: AppState) => state.mediaRevamp.dateRangeFilter);
  const highlightedDate = useMemo(() => {
    if (activeFilter && activeFilter.type === type) {
      return new Date(activeFilter.value);
    } else return new Date();
  }, [activeFilter, type]);
  return <Dialog open={open} onClose={onClose} data-sentry-element="Dialog" data-sentry-component="DateFilterModal" data-sentry-source-file="DateFilterModal.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="DateFilterModal.tsx">
        <Stack direction="row" justifyContent="space-between" alignContent="center" data-sentry-element="Stack" data-sentry-source-file="DateFilterModal.tsx">
          <Typography variant="h5" sx={{
          textTransform: "capitalize"
        }} data-sentry-element="Typography" data-sentry-source-file="DateFilterModal.tsx">
            {type}
          </Typography>
          <IconButton onClick={() => onClose()} data-sentry-element="IconButton" data-sentry-source-file="DateFilterModal.tsx">
            <CloseIcon fontSize="small" data-sentry-element="CloseIcon" data-sentry-source-file="DateFilterModal.tsx" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{
      px: 0
    }} data-sentry-element="DialogContent" data-sentry-source-file="DateFilterModal.tsx">
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale(i18n.language)} data-sentry-element="LocalizationProvider" data-sentry-source-file="DateFilterModal.tsx">
          <DateCalendar onChange={(date, state) => {
          setDateCallback(date);
          onClose();
        }} value={highlightedDate} data-sentry-element="DateCalendar" data-sentry-source-file="DateFilterModal.tsx" />
        </LocalizationProvider>
      </DialogContent>
    </Dialog>;
};